module.exports = __webpack_public_path__ + "static/img/001.c460b85f.png";